import { useState } from 'react'
import { useViewportSize } from '@mantine/hooks'
import { useSearchParams } from 'react-router-dom'
import { motion, AnimatePresence } from 'motion/react'

import Breadcrumbs from '@/components/ui/Breadcrumbs'
import CommentsList from '@/components/ui/CommentsList'
import CommentsButton from '@/components/ui/CommentsButton'
import useMe from '@/hooks/useMe'
import { MOBILE_BREAKPOINT } from '@/lib/constants'

export default function ScrollableScreen({
    children,
    breadcrumbs = [],
    rightSection = null,
    footer = null,
    commentableType = null,
    commentableId = null,
}) {
    const [searchParams, setSearchParams] = useSearchParams()
    const [panelOpen, setPanelOpen] = useState(false)
    const { width } = useViewportSize()
    const { isAdmin } = useMe()
    const hasComments = isAdmin && commentableType && commentableId
    const isOpen = panelOpen || searchParams.get('comments') === 'open'
    const isMobile = width > 0 && width <= MOBILE_BREAKPOINT

    const closePanel = () => {
        setPanelOpen(false)
        setSearchParams((prev) => {
            const next = new URLSearchParams(prev)
            next.delete('comments')
            return next
        }, { replace: true })
    }

    const commentsButton = hasComments ? (
        <CommentsButton
            commentableType={commentableType}
            commentableId={commentableId}
            onClick={!isMobile ? (() => isOpen ? closePanel() : setPanelOpen(true)) : null}
        />
    ) : null

    const combinedRightSection = (
        <>
            {commentsButton}
            {rightSection}
        </>
    )

    return (
        <div className="h-full w-full relative bg-gray-50">
            <div className="absolute inset-0 flex flex-col">
                <div className="bg-gray-50/80 backdrop-blur-xs pt-3 pb-3 border-b border-gray-200/60 sticky top-0 z-10">
                    <Breadcrumbs
                        breadcrumbs={breadcrumbs}
                        rightSection={combinedRightSection}
                        noTopMargin
                    />
                </div>

                <div className="flex-1 flex overflow-hidden">
                    <div className="flex-1 overflow-y-auto overflow-x-hidden overscroll-y-contain">
                        {children}
                        {footer}
                    </div>

                    <AnimatePresence initial={false}>
                        {hasComments && isOpen && !isMobile && (
                            <motion.div
                                initial={{ width: 0, opacity: 0 }}
                                animate={{ width: 420, opacity: 1 }}
                                exit={{ width: 0, opacity: 0 }}
                                transition={{ duration: 0.2, ease: 'easeInOut' }}
                                className="shrink-0 border-l border-gray-200/60 bg-white overflow-hidden"
                            >
                                <div className="w-[420px] h-full">
                                    <CommentsList
                                        commentable_type={commentableType}
                                        commentable_id={commentableId}
                                        onClose={closePanel}
                                    />
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </div>

        </div>
    )
}
